import { createAsyncThunk } from "@reduxjs/toolkit";
import { RecoverAPIs, ExportRecoveryDetailsRequest } from "../../../api/recovery";

export const fetchRecoveryDetailsThunk = createAsyncThunk<
  ExportRecoveryDetailsRequest,
  { case_id: string },
  { rejectValue: string }
>("recovery/fetchRecoveryDetails", async ({ case_id }, { rejectWithValue }) => {
  try {
    return await RecoverAPIs.getRecoveryDetails(case_id);
  } catch (error: any) {
    return rejectWithValue(error?.message || "Failed to fetch recovery details");
  }
});

export const upsertRecoveryDetailsThunk = createAsyncThunk<
  ExportRecoveryDetailsRequest,
  { case_id: string; request: ExportRecoveryDetailsRequest },
  { rejectValue: string }
>(
  "recovery/upsertRecoveryDetails",
  async ({ case_id, request }, { rejectWithValue }) => {
    try {
      return await RecoverAPIs.upsertRecoveryDetails(case_id, request);
    } catch (error: any) {
      return rejectWithValue(
        error?.message || "Failed to upsert recovery details"
      );
    }
  }
);


